// import React, { useMemo } from 'react';
// import { Card, CardContent, Typography, Box, Stack } from '@mui/material';
// import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// // --- Interface for incoming data points ---
// interface LlmUsageDataPoint {
//   date: string; // Expecting a date string like "2025-05-13"
//   openAI: number;
//   gemini: number;
// }

// const legendItems = [
//   { name: 'Open AI', color: '#0064FF' },
//   { name: 'Gemini', color: '#FFA600' },
// ];

// // --- Custom component for the Y-Axis Tick ---
// const CustomYAxisTick = (props: any) => {
//   const { x, y, payload } = props;
//   if (!payload || payload.value === undefined) return null;

//   const value = payload.value;
//   let label;

//   if (value >= 1000) {
//     label = `${value / 1000}k`;
//   } else {
//     label = value;
//   }

//   return (
//     <g transform={`translate(${x},${y})`}>
//       <text x={0} y={0} dy={4} textAnchor="end" fill="#666" style={{ fontSize: 12, fontFamily: 'Inter' }}>
//         {label}
//       </text>
//     </g>
//   );
// };

// // --- MODIFICATION: Tooltip updated to match the reference design ---
// const CustomTooltip = ({ active, payload, label }: any) => {
//   if (!active || !payload || !payload.length || typeof label !== 'string' || label === "") {
//     return null;
//   }
  
//   const date = new Date(label);
//   if (isNaN(date.getTime())) {
//     console.error("LlmUsageChart CustomTooltip: Invalid date label:", label);
//     return null;
//   }

//   const dataOpenAI = payload.find((p: { dataKey: string; }) => p.dataKey === 'openAI');
//   const dataGemini = payload.find((p: { dataKey: string; }) => p.dataKey === 'gemini');

//   if (!dataOpenAI || !dataGemini || typeof dataOpenAI.value !== 'number' || typeof dataGemini.value !== 'number') {
//       console.error("LlmUsageChart CustomTooltip: Invalid or missing data in payload:", payload);
//       return null;
//   }

//   // Matched date format from reference
//   const formattedDate = `${new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date)}, ${date.getDate()} ${new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date)} • ${date.getFullYear()}`;

//   return (
//     // Matched container styles from reference
//     <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', minHeight: '100px', fontFamily: 'Inter' }}>
//       <Typography sx={{ fontSize: '12px', color: '#C9C9C9', marginBottom: '12px', textAlign: 'center' }}>
//         {formattedDate}
//       </Typography>
//       <Stack spacing={1}>
//         {/* Matched row styles from reference */}
//         <Stack direction="row" justifyContent="space-between" alignItems="center">
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <FiberManualRecordIcon sx={{ color: '#0064FF', fontSize: '10px', mr: 0.75 }} />
//             <Typography sx={{ fontSize: '12px', fontWeight: 400 ,  mr: 10, color:'#666666'}}>Open AI</Typography>
//           </Box>
//           <Typography sx={{ fontSize: '12px', fontWeight: 500, color:'#333333' }}>
//             {`${dataOpenAI.value.toLocaleString()} tokens`}
//           </Typography>
//         </Stack>
//         <Stack direction="row" justifyContent="space-between" alignItems="center">
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <FiberManualRecordIcon sx={{ color: '#FFA600', fontSize: '10px', mr: 0.75 }} />
//             <Typography sx={{ fontSize: '12px', fontWeight: 400,  mr: 10 , color:'#666666'}}>Gemini</Typography>
//           </Box>
//           <Typography sx={{ fontSize: '12px', fontWeight: 500, color:'#333333' }}>
//             {`${dataGemini.value.toLocaleString()} tokens`}
//           </Typography>
//         </Stack>
//       </Stack>
//     </Card>
//   );
// };

// // --- Mock Data Generation ---
// const generateMockData = (): LlmUsageDataPoint[] => {
//     return Array.from({ length: 30 }, (_, i) => {
//         const date = new Date(2025, 4, i + 1); // May 2025
//         return {
//             date: date.toISOString().split('T')[0], // "2025-05-13"
//             openAI: Math.round(80000 + Math.sin(i / 3) * 20000 + Math.random() * 15000),
//             gemini: Math.round(100000 - Math.cos(i / 4) * 25000 + Math.random() * 20000),
//         }
//     });
// };


// const LlmUsageChart: React.FC = () => {
//   const mockData = useMemo(() => generateMockData(), []);

//   const { yAxisDomain, yAxisTicks } = useMemo(() => {
//     if (!mockData || mockData.length === 0) {
//       return { yAxisDomain: [0, 100000], yAxisTicks: [0, 25000, 50000, 75000, 100000] };
//     }

//     const maxOpenAI = Math.max(...mockData.map(item => item.openAI || 0));
//     const maxGemini = Math.max(...mockData.map(item => item.gemini || 0));
//     const maxVal = Math.max(maxOpenAI, maxGemini);

//     if (maxVal === 0) {
//         return { yAxisDomain: [0, 100000], yAxisTicks: [0, 25000, 50000, 75000, 100000] };
//     }
    
//     const magnitude = Math.pow(10, Math.floor(Math.log10(maxVal)));
//     const niceUpperBound = Math.ceil(maxVal / magnitude) * magnitude;
    
//     const tickCount = 5;
//     const ticks = Array.from({ length: tickCount }, (_, i) => i * (niceUpperBound / (tickCount - 1)));

//     return { yAxisDomain: [0, niceUpperBound], yAxisTicks: ticks };
//   }, [mockData]);

//   const yAxisWidth = useMemo(() => {
//     if (!yAxisTicks || yAxisTicks.length === 0) return 60;
//     const maxTick = yAxisTicks[yAxisTicks.length - 1];
//     const maxLabel = maxTick >= 1000 ? `${maxTick / 1000}k` : `${maxTick}`;
//     return maxLabel.length * 8 + 15;
//   }, [yAxisTicks]);

//   return (
//     <Card elevation={0} sx={{ borderRadius: '16px', height: '400px', width: '100%', fontFamily: 'Inter, sans-serif' }}>
//       <CardContent sx={{ p: { xs: 2, md: 3 }, display: 'flex', flexDirection: 'column', height: '100%' }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
//           <Typography variant="h6" component="h3" sx={{ fontWeight: '600', fontSize: '16px' }}>
//             LLM Usage
//           </Typography>
//           <Stack direction="row" spacing={2.5} alignItems="center">
//             {legendItems.map((item) => (
//               <Box key={item.name} sx={{ display: 'flex', alignItems: 'center' }}>
//                 <FiberManualRecordIcon sx={{ color: item.color, fontSize: '10px', mr: 0.75 }} />
//                 <Typography variant="caption" sx={{ color: 'text.secondary' }}>
//                   {item.name}
//                 </Typography>
//               </Box>
//             ))}
//           </Stack>
//         </Box>
//         <Box sx={{ width: '100%', height: '320px' }}>
//           <ResponsiveContainer width="100%" height="100%">
//             <LineChart data={mockData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
//                 <defs>
//                     <linearGradient id="gradientOpenAI" x1="0" y1="0" x2="1" y2="0">
//                         <stop offset="0%" stopColor="#AECBFA" />
//                         <stop offset="50%" stopColor="#0064FF" />
//                         <stop offset="100%" stopColor="#AECBFA" />
//                     </linearGradient>
//                     <linearGradient id="gradientGemini" x1="0" y1="0" x2="1" y2="0">
//                         <stop offset="0%" stopColor="#FFE0B2" />
//                         <stop offset="50%" stopColor="#FFA600" />
//                         <stop offset="100%" stopColor="#FFE0B2" />
//                     </linearGradient>
//                 </defs>
//               <CartesianGrid strokeDasharray="6 6" stroke="#E4EAF0" horizontal={true} vertical={false} />
//               <XAxis dataKey="date" hide={true} />
//               <YAxis
//                 axisLine={false}
//                 tickLine={false}
//                 domain={yAxisDomain}
//                 ticks={yAxisTicks}
//                 tick={<CustomYAxisTick />}
//                 width={yAxisWidth}
//               />
//               <Tooltip
//                 cursor={{ stroke: '#CBD5DE', strokeWidth: 1.5, strokeDasharray: '5 5' }}
//                 content={<CustomTooltip />}
//                 wrapperStyle={{ zIndex: 1000 }}
//               />
//               <Line type="monotone" dataKey="openAI" stroke="url(#gradientOpenAI)" strokeWidth={2.5} dot={false} activeDot={{ r: 6, stroke: 'white', strokeWidth: 2, fill: '#0064FF' }} />
//               <Line type="monotone" dataKey="gemini" stroke="url(#gradientGemini)" strokeWidth={2.5} dot={false} activeDot={{ r: 6, stroke: 'white', strokeWidth: 2, fill: '#FFA600' }} />
//             </LineChart>
//           </ResponsiveContainer>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// export default LlmUsageChart;


import React, { useMemo } from 'react';
import { Card, CardContent, Typography, Box, Stack, Skeleton } from '@mui/material';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// --- MODIFIED: Predefined palette for the first 6 models ---
// const PREDEFINED_PALETTE = [
//   '#0064FF', // 1st model
//   '#FBBC05', // 2nd model
//   '#BF83FF', // 3rd model
//   '#3CD856', // 4th model
//   '#FF947A', // 5th model
//   '#FA5A7D', // 6th model
// ];
const PREDEFINED_PALETTE = [
  '#0064FF', '#FFA600', '#FF3023', '#67B341', '#029F8C', '#9B2B11', '#E75D0F', '#AE46BC',
  '#180273','#5B733D', '#6C63C8', '#8C8C8C'
];

/**
 * Generates a deterministic color for any models beyond the first 6.
 */
const stringToColor = (str: string): string => {
  let hash = 0;
  str.split('').forEach(char => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
};

// --- Type Definitions ---
type TooltipPayloadItem = {
  value: number;
  dataKey: string;
};

interface LlmUsageDataPointBE {
  date: string;
  models: { [key: string]: number };
}

interface LlmUsageChartProps {
  usageData?: LlmUsageDataPointBE[];
  isLoading?: boolean;
}

// --- Custom Components ---
const CustomTooltip = ({ active, payload, label, modelInfo }: any) => {
  if (!active || !payload || !payload.length || typeof label !== 'string' || label === "") return null;
  const date = new Date(label);
  if (isNaN(date.getTime())) return null;

  const formattedDate = `${new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date)}, ${date.getDate()} ${new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date)} • ${date.getFullYear()}`;

  return (
    <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '220px', fontFamily: 'Inter' }}>
      <Typography sx={{ fontSize: '12px', color: '#C9C9C9', marginBottom: '12px', textAlign: 'center' }}>{formattedDate}</Typography>
      <Stack spacing={1}>
        {payload
          .sort((a: TooltipPayloadItem, b: TooltipPayloadItem) => b.value - a.value)
          .map((p: TooltipPayloadItem) => {
            const info = modelInfo[p.dataKey];
            if (!info || typeof p.value !== 'number' || p.value === 0) return null;
            return (
              <Stack key={p.dataKey} direction="row" justifyContent="space-between" alignItems="center">
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <FiberManualRecordIcon sx={{ color: info.color, fontSize: '10px', mr: 0.75 }} />
                  <Typography sx={{ fontSize: '12px', fontWeight: 400, mr: 4, color: '#666666' }}>{info.name}</Typography>
                </Box>
                <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#333333' }}>{`${p.value.toLocaleString()} tokens`}</Typography>
              </Stack>
            );
        })}
      </Stack>
    </Card>
  );
};

const CustomYAxisTick = (props: any) => {
  const { x, y, payload } = props;
  if (!payload || payload.value === undefined) return null;
  const label = payload.value.toLocaleString();
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={4} textAnchor="end" fill="#666" style={{ fontSize: 12, fontFamily: 'Inter' }}>{label}</text>
    </g>
  );
};

// --- Main Chart Component ---
const LlmUsageChart: React.FC<LlmUsageChartProps> = ({ usageData, isLoading }) => {

  const modelInfo = useMemo(() => {
    if (!usageData) return {};
    // Create a stable, ordered list of unique model keys
    const allModelKeys = Array.from(new Set(usageData.flatMap(day => Object.keys(day.models))));

    const info: { [key: string]: { name: string; color: string } } = {};
    
    // MODIFIED: Assign colors using the new hybrid logic
    allModelKeys.forEach((key, index) => {
      const color = index < PREDEFINED_PALETTE.length
        ? PREDEFINED_PALETTE[index]       // Use predefined color
        : stringToColor(key);            // Fall back to generated color
      
      info[key] = {
        name: key,
        color: color,
      };
    });
    return info;
  }, [usageData]);

  const legendItems = useMemo(() => Object.entries(modelInfo).map(([dataKey, { name, color }]) => ({
      dataKey, name, color
  })), [modelInfo]);

  const transformedData = useMemo(() => {
    if (!usageData) return [];
    const allModelKeys = Object.keys(modelInfo);
    
    return usageData.map(day => {
      const dataPoint: { [key: string]: string | number } = { date: day.date };
      allModelKeys.forEach(key => { dataPoint[key] = 0; });
      for (const modelKey in day.models) {
        if (allModelKeys.includes(modelKey)) {
          dataPoint[modelKey] = day.models[modelKey];
        }
      }
      return dataPoint;
    });
  }, [usageData, modelInfo]);

  const { yAxisDomain, yAxisTicks } = useMemo(() => {
    if (!transformedData || transformedData.length === 0) {
      return { yAxisDomain: [0, 1000], yAxisTicks: [0, 250, 500, 750, 1000] };
    }
    const allModelKeys = Object.keys(modelInfo);
    const maxVal = Math.max(0, ...transformedData.map(item =>
      Math.max(...allModelKeys.map(key => (item[key] as number) || 0))
    ));

    if (maxVal === 0) return { yAxisDomain: [0, 100], yAxisTicks: [0, 25, 50, 75, 100] };
    
    const magnitude = Math.pow(10, Math.floor(Math.log10(maxVal)));
    const niceUpperBound = Math.ceil(maxVal / magnitude) * magnitude;
    const tickCount = 5;
    const ticks = Array.from({ length: tickCount }, (_, i) => Math.round(i * (niceUpperBound / (tickCount - 1))));

    return { yAxisDomain: [0, 'auto'], yAxisTicks: ticks };
  }, [transformedData, modelInfo]);

  const yAxisWidth = useMemo(() => {
    if (!yAxisTicks || yAxisTicks.length === 0) return 60;
    const longestLabel = yAxisTicks.reduce((longest, currentTick) => {
      const currentLabel = currentTick.toLocaleString();
      return currentLabel.length > longest.length ? currentLabel : longest;
    }, "");
    return longestLabel.length * 8 + 20;
  }, [yAxisTicks]);

  return (
    <Card elevation={0} sx={{ borderRadius: '16px', height: '400px', width: '100%', fontFamily: 'Inter, sans-serif' }}>
      <CardContent sx={{ p: { xs: 2, md: 3 }, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
          <Typography variant="h6" component="h3" sx={{ fontWeight: '600', fontSize: '16px', mr: 2 }}>
            LLM Usage
          </Typography>
          <Stack
            direction="row"
            spacing={2.5}
            alignItems="center"
            sx={{
              maxWidth: '60%',
              overflowX: 'auto',
              overflowY: 'hidden',
              flexWrap: 'nowrap',
              pb: 1,
              '::-webkit-scrollbar': { height: '4px' },
              '::-webkit-scrollbar-thumb': { backgroundColor: '#d1d5db', borderRadius: '2px' },
            }}
          >
            {legendItems.map((item) => (
              <Box key={item.name} sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                <FiberManualRecordIcon sx={{ color: item.color, fontSize: '10px', mr: 0.75 }} />
                <Typography variant="caption" sx={{ color: 'text.secondary', whiteSpace: 'nowrap' }}>
                  {item.name}
                </Typography>
              </Box>
            ))}
          </Stack>
        </Box>
        <Box sx={{ width: '100%', height: '100%', maxHeight: '320px' }}>
          {isLoading ? (
            <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: '8px' }}/>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={transformedData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E4EAF0" horizontal={true} vertical={false} />
                <XAxis dataKey="date" hide={true} />
                <YAxis
                  axisLine={false}
                  tickLine={false}
                  ticks={yAxisTicks}
                  tick={<CustomYAxisTick />}
                  width={yAxisWidth}
                />
                <Tooltip
                  cursor={{ stroke: '#CBD5DE', strokeWidth: 1, strokeDasharray: '3 3' }}
                  content={<CustomTooltip modelInfo={modelInfo} />}
                  wrapperStyle={{ zIndex: 1000 }}
                />
                {legendItems.map(item => (
                  <Line 
                    key={item.dataKey}
                    type="monotone" 
                    dataKey={item.dataKey}
                    stroke={item.color}
                    strokeWidth={2} 
                    dot={false} 
                    activeDot={{ r: 5, stroke: 'white', strokeWidth: 2, fill: item.color }} 
                  />
                ))}
              </LineChart>
            </ResponsiveContainer>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default LlmUsageChart;



///test 
// import React, { useMemo } from 'react';
// import { Card, CardContent, Typography, Box, Stack, Skeleton } from '@mui/material';
// import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// // --- Interfaces (placing LlmUsageDataPointBE before it's used) ---
// interface LlmUsageDataPointBE {
//   date: string;
//   models: { [key: string]: number };
// }

// // --- MOCK DATA FOR TESTING (with explicit type) ---
// const mockDataFor6Colors: LlmUsageDataPointBE[] = [
//   {
//     date: '2025-08-12',
//     models: {
//       'gemini-1.5-pro': 2051,
//       'gpt-4-turbo': 1840,
//       'claude-3-opus': 3100,
//       'llama-3-70b-instruct': 2500,
//       'gpt-3.5-turbo': 950,
//       'mistral-large-latest': 1570,
//     },
//   },
// ];


// const PREDEFINED_PALETTE = [
//   '#0064FF', '#FBBC05', '#BF83FF', '#3CD856', '#FF947A', '#FA5A7D',
// ];

// const stringToColor = (str: string): string => {
//   let hash = 0;
//   str.split('').forEach(char => {
//     hash = char.charCodeAt(0) + ((hash << 5) - hash);
//   });
//   let color = '#';
//   for (let i = 0; i < 3; i++) {
//     const value = (hash >> (i * 8)) & 0xFF;
//     color += `00${value.toString(16)}`.slice(-2);
//   }
//   return color;
// };

// type TooltipPayloadItem = {
//   value: number;
//   dataKey: string;
// };

// interface LlmUsageChartProps {
//   usageData?: LlmUsageDataPointBE[];
//   isLoading?: boolean;
// }

// const CustomTooltip = ({ active, payload, label, modelInfo }: any) => {
//   if (!active || !payload || !payload.length || typeof label !== 'string' || label === "") return null;
//   const date = new Date(label);
//   if (isNaN(date.getTime())) return null;

//   const formattedDate = `${new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date)}, ${date.getDate()} ${new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date)} • ${date.getFullYear()}`;

//   return (
//     <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '220px', fontFamily: 'Inter' }}>
//       <Typography sx={{ fontSize: '12px', color: '#C9C9C9', marginBottom: '12px', textAlign: 'center' }}>{formattedDate}</Typography>
//       <Stack spacing={1}>
//         {payload
//           .sort((a: TooltipPayloadItem, b: TooltipPayloadItem) => b.value - a.value)
//           .map((p: TooltipPayloadItem) => {
//             const info = modelInfo[p.dataKey];
//             if (!info || typeof p.value !== 'number' || p.value === 0) return null;
//             return (
//               <Stack key={p.dataKey} direction="row" justifyContent="space-between" alignItems="center">
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <FiberManualRecordIcon sx={{ color: info.color, fontSize: '10px', mr: 0.75 }} />
//                   <Typography sx={{ fontSize: '12px', fontWeight: 400, mr: 4, color: '#666666' }}>{info.name}</Typography>
//                 </Box>
//                 <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#333333' }}>{`${p.value.toLocaleString()} tokens`}</Typography>
//               </Stack>
//             );
//         })}
//       </Stack>
//     </Card>
//   );
// };

// const CustomYAxisTick = (props: any) => {
//   const { x, y, payload } = props;
//   if (!payload || payload.value === undefined) return null;
//   const label = payload.value.toLocaleString();
//   return (
//     <g transform={`translate(${x},${y})`}>
//       <text x={0} y={0} dy={4} textAnchor="end" fill="#666" style={{ fontSize: 12, fontFamily: 'Inter' }}>{label}</text>
//     </g>
//   );
// };

// const LlmUsageChart: React.FC<LlmUsageChartProps> = ({ usageData, isLoading }) => {
//   // FOR TESTING: This line forces the component to use the mock data.
//   const dataToUse = mockDataFor6Colors;

//   const modelInfo = useMemo(() => {
//     if (!dataToUse) return {};
//     const allModelKeys = Array.from(new Set(dataToUse.flatMap(day => Object.keys(day.models))));

//     const info: { [key: string]: { name: string; color: string } } = {};
    
//     allModelKeys.forEach((key, index) => {
//       const color = index < PREDEFINED_PALETTE.length
//         ? PREDEFINED_PALETTE[index]
//         : stringToColor(key);
      
//       info[key] = {
//         name: key,
//         color: color,
//       };
//     });
//     return info;
//   }, [dataToUse]);

//   const legendItems = useMemo(() => Object.entries(modelInfo).map(([dataKey, { name, color }]) => ({
//       dataKey, name, color
//   })), [modelInfo]);

//   const transformedData = useMemo(() => {
//     if (!dataToUse) return [];
//     const allModelKeys = Object.keys(modelInfo);
    
//     return dataToUse.map(day => {
//       const dataPoint: { [key: string]: string | number } = { date: day.date };
//       allModelKeys.forEach(key => { dataPoint[key] = 0; });
//       for (const modelKey in day.models) {
//         if (allModelKeys.includes(modelKey)) {
//           dataPoint[modelKey] = day.models[modelKey];
//         }
//       }
//       return dataPoint;
//     });
//   }, [dataToUse, modelInfo]);

//   const { yAxisDomain, yAxisTicks } = useMemo(() => {
//     if (!transformedData || transformedData.length === 0) {
//       return { yAxisDomain: [0, 1000], yAxisTicks: [0, 250, 500, 750, 1000] };
//     }
//     const allModelKeys = Object.keys(modelInfo);
//     const maxVal = Math.max(0, ...transformedData.map(item =>
//       Math.max(...allModelKeys.map(key => (item[key] as number) || 0))
//     ));

//     if (maxVal === 0) return { yAxisDomain: [0, 100], yAxisTicks: [0, 25, 50, 75, 100] };
    
//     const magnitude = Math.pow(10, Math.floor(Math.log10(maxVal)));
//     const niceUpperBound = Math.ceil(maxVal / magnitude) * magnitude;
//     const tickCount = 5;
//     const ticks = Array.from({ length: tickCount }, (_, i) => Math.round(i * (niceUpperBound / (tickCount - 1))));

//     return { yAxisDomain: [0, 'auto'], yAxisTicks: ticks };
//   }, [transformedData, modelInfo]);

//   const yAxisWidth = useMemo(() => {
//     if (!yAxisTicks || yAxisTicks.length === 0) return 60;
//     const longestLabel = yAxisTicks.reduce((longest, currentTick) => {
//       const currentLabel = currentTick.toLocaleString();
//       return currentLabel.length > longest.length ? currentLabel : longest;
//     }, "");
//     return longestLabel.length * 8 + 20;
//   }, [yAxisTicks]);

//   return (
//     <Card elevation={0} sx={{ borderRadius: '16px', height: '400px', width: '100%', fontFamily: 'Inter, sans-serif' }}>
//       <CardContent sx={{ p: { xs: 2, md: 3 }, display: 'flex', flexDirection: 'column', height: '100%' }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
//           <Typography variant="h6" component="h3" sx={{ fontWeight: '600', fontSize: '16px', mr: 2 }}>
//             LLM Usage
//           </Typography>
//           <Stack
//             direction="row"
//             spacing={2.5}
//             alignItems="center"
//             sx={{
//               maxWidth: '60%',
//               overflowX: 'auto',
//               overflowY: 'hidden',
//               flexWrap: 'nowrap',
//               pb: 1,
//               '::-webkit-scrollbar': { height: '4px' },
//               '::-webkit-scrollbar-thumb': { backgroundColor: '#d1d5db', borderRadius: '2px' },
//             }}
//           >
//             {legendItems.map((item) => (
//               <Box key={item.name} sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
//                 <FiberManualRecordIcon sx={{ color: item.color, fontSize: '10px', mr: 0.75 }} />
//                 <Typography variant="caption" sx={{ color: 'text.secondary', whiteSpace: 'nowrap' }}>
//                   {item.name}
//                 </Typography>
//               </Box>
//             ))}
//           </Stack>
//         </Box>
//         <Box sx={{ width: '100%', height: '100%', maxHeight: '320px' }}>
//           {isLoading ? (
//             <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: '8px' }}/>
//           ) : (
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={transformedData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
//                 <CartesianGrid strokeDasharray="3 3" stroke="#E4EAF0" horizontal={true} vertical={false} />
//                 <XAxis dataKey="date" hide={true} />
//                 <YAxis
//                   axisLine={false}
//                   tickLine={false}
//                   ticks={yAxisTicks}
//                   tick={<CustomYAxisTick />}
//                   width={yAxisWidth}
//                 />
//                 <Tooltip
//                   cursor={{ stroke: '#CBD5DE', strokeWidth: 1, strokeDasharray: '3 3' }}
//                   content={<CustomTooltip modelInfo={modelInfo} />}
//                   wrapperStyle={{ zIndex: 1000 }}
//                 />
//                 {legendItems.map(item => (
//                   <Line 
//                     key={item.dataKey}
//                     type="monotone" 
//                     dataKey={item.dataKey}
//                     stroke={item.color}
//                     strokeWidth={2} 
//                     dot={false} 
//                     activeDot={{ r: 5, stroke: 'white', strokeWidth: 2, fill: item.color }} 
//                   />
//                 ))}
//               </LineChart>
//             </ResponsiveContainer>
//           )}
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// export default LlmUsageChart;